document.addEventListener("DOMContentLoaded", function () {
  class MobileMenu extends HTMLElement {
    constructor() {
      super();

      this.subLinks = this.querySelectorAll('[data-menu-item-handle]');
      this.subMenus = this.querySelectorAll('[data-menu-sub-handle]');
      this.subBacks = this.querySelectorAll('.sub-back');

      this.hanleLinkClick = this.hanleLinkClick.bind(this);
      this.hanleBack = this.hanleBack.bind(this);
    }

    connectedCallback() {
      this.subLinks.forEach(subLink => subLink.addEventListener('click', this.hanleLinkClick));
      this.subBacks.forEach(back => back.addEventListener('click', this.hanleBack));
    }

    diconnectedCallback() {
      this.subLinks.forEach(subLink => subLink.removeEventListener('click', this.hanleLinkClick));
      this.subBacks.forEach(back => back.removeEventListener('click', this.hanleBack));
    }

    hanleLinkClick(e) {
      e.preventDefault();
      const handle = e.currentTarget.getAttribute('data-menu-item-handle');
      const subMenu = [...this.subMenus].find(subMenu => subMenu.getAttribute('data-menu-sub-handle') === handle);

      subMenu.classList.add('active');
    }

    hanleBack(e) {
      const subMenu = e.currentTarget.closest('.hg-tva--sub');
      subMenu.classList.remove('active');
    }
  }

  customElements.define('mobile-menu', MobileMenu);
});